import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const InsurancePriorityForm = (props) => {
    const initialFormData = {
        insurancepriority: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    const formRef = useRef(null);

    useEffect(() => {
        const val = props.insprvalue;
        if (val && (val.priority_id || val.insurancepriority_id || val.id)) {
            const { priority, insurancepriority, is_active, priority_id, insurancepriority_id, id } = val;
            setFormData({
                insurancepriority: priority || insurancepriority || "",
                isactive: is_active == 1 || is_active === '1' || is_active === true,
                id: priority_id || insurancepriority_id || id || ""
            });
            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        } else {
            setFormData(initialFormData);
            setButtonStatus(mapYourMedsConstant.ADD_ACTION);
        }
    }, [props.edittrigger, props.insprvalue]);

    const isAddMode = buttonStatus === "Add" || buttonStatus === mapYourMedsConstant.ADD_ACTION;

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsInsPrUrl = isAddMode ? `${process.env.REACT_APP_SERVER_URL}/patients/add-patient-insurance-priority` :
            `${process.env.REACT_APP_SERVER_URL}/patients/update-patient-insurance-priority`;

        let pelmedsInsPrData = isAddMode ? 
            { "priority": formData.insurancepriority, "group_id": localStorage.getItem("groupId") || '', "is_active": 1 } :
            { "priority": formData.insurancepriority, "group_id": localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "id": formData.id };

        const { data } = await axios.post(pelmedsInsPrUrl, pelmedsInsPrData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success(isAddMode ? "Insurance Priority added successfully" : "Insurance Priority updated successfully");
        }
        else {
            toast.info("Error while adding/updating Insurance Priority");
        }

        setFormData(initialFormData);
        formRef.current.reset();
        setButtonStatus("Add");

        if (props.onCallParent) {
            props.onCallParent();
        }
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Insurance Priority</Form.Label>
                        <Form.Control
                            placeholder='Insurance Priority'
                            value={formData.insurancepriority}
                            name="insurancepriority"
                            size="sm"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            size="sm"
                            className="mt-4 w-50"
                            disabled={!formData.insurancepriority}>
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={isAddMode ? true : formData.isactive}
                            disabled={isAddMode}
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};

InsurancePriorityForm.propTypes = {
    insprvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default InsurancePriorityForm;
